module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "debug-block__field"
  }, [_c('p', [_vm._v("\n    访问本地192.168.\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ipInput.ip0),
      expression: "ipInput.ip0"
    }],
    staticClass: "debug-block__ip",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ipInput.ip0)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ipInput, "ip0", $event.target.value)
      }
    }
  }), _vm._v(".\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ipInput.ip1),
      expression: "ipInput.ip1"
    }],
    staticClass: "debug-block__ip",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ipInput.ip1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ipInput, "ip1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(" : ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ipInput.port),
      expression: "ipInput.port"
    }],
    staticClass: "debug-block__ip",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ipInput.port)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.ipInput, "port", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "debug-block__button",
    on: {
      "click": _vm.linkToClick
    }
  }, [_vm._v("前进\n    ")])]), _vm._v(" "), _c('p', [_vm._v("\n    自定义："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ipCustom),
      expression: "ipCustom"
    }],
    staticClass: "debug-block__custom",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.ipCustom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ipCustom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "debug-block__button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.linkToCustomClick
    }
  }, [_vm._v("前进")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "debug-block__link",
    on: {
      "click": function($event) {
        _vm.locationTo(_vm.testServer)
      }
    }
  }, [_vm._v("访问测试服务\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fdc38804"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/items/DebugBlock/UrlInput.vue
// module id = 929
// module chunks = 1